import { Component, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { LogoutTimerComponent } from './public/logoutTimer/logoutTimer.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from './services/auth.service';
import { environment } from '../environments/environment';
import { startAppUpdateCheck } from './services/app-update';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'My Easy Prop';
  appVersion = environment.version || 'dev';
  public timeDifference;
  private subscription: Subscription;
  private dialogRef;
  private logoutModal = 0;

  constructor(public dialog: MatDialog, private authService: AuthService,) {}

  ngOnInit() {
    // Pick up a new deploy even when iOS keeps an old tab/bundle alive.
    startAppUpdateCheck(this.appVersion);
    this.subscription = interval(1000)
           .subscribe(x => { this.getTimeDifference(); });
  }

  private getTimeDifference () {
      const ud = localStorage.getItem('auth');
      if (ud != null){
        const ud_json = JSON.parse(ud);
        this.timeDifference = Math.trunc((ud_json.expr - new  Date().getTime())/1000);
        //console.log(this.timeDifference);
        if (this.timeDifference < 900 && this.timeDifference > 2 && !this.logoutModal){
          // this.logout();
          this.dialogRef = this.dialog.open(LogoutTimerComponent, {
            width: '800px',
            maxWidth: '100vw',
            panelClass: 'mobile-dialog-panel',
            autoFocus: false
          });
          this.logoutModal=1;
        } else if (this.timeDifference < 1){
          this.dialogRef.close();
          this.authService.logout();
          this.logoutModal=0;
        } else if(this.timeDifference > 900 && this.timeDifference && this.logoutModal){
          this.logoutModal=0;
        }
      } else {
          this.timeDifference = 0;
          this.logoutModal=0;
      }
  }

  get TimeDifference(){
    return this.timeDifference;
  }

  resetLogoutModal(){
    this.logoutModal=0;
  }

  private dialogWidth(defaultWidth: string) {
    return window.innerWidth < 768 ? '95vw' : defaultWidth;
  }

  isAuthenticatedPage(): boolean {
    // Pages that use sidebar navigation instead of top nav
    const sidebarPages = ['/admin-landing', '/super-admin', '/lessee-landing'];
    const currentPath = window.location.pathname;
    return sidebarPages.some(function(page) {
      return currentPath.includes(page);
    });
  }
}
